import Button from "../../Button";

function safeParseJSON(str) {
  if (!str || typeof str !== "string") return null;
  try {
    const clean = str.replace(/[\u0000-\u001F\u007F-\u009F]/g, "");
    return JSON.parse(clean);
  } catch (e) {
    console.error("❌ safeParseJSON パースエラー:", e, "元の文字列:", str);
    return null;
  }
}

export default function Question({ question, onAnswer, selectedTags = {}, type }) {
  if (!question) return null;

  const choices = Array.isArray(question.choices)
    ? question.choices
    : safeParseJSON(question.choices) || [];

  const isBusiness = type === "business";
  const isBusiness06 = isBusiness && question.id === "business_06";

  let scores = [];
  if (!isBusiness06) {
    if (Array.isArray(question.scores)) {
      scores = question.scores;
    } else if (typeof question.scores === "string") {
      const parsed = safeParseJSON(question.scores);
      if (Array.isArray(parsed)) scores = parsed;
    }
  }

  const redirects = isBusiness06
    ? Array.isArray(question.redirects)
      ? question.redirects
      : safeParseJSON(question.redirects) || []
    : [];

  function handleClick(index) {
    if (isBusiness06) {
      const redirectObj = redirects[index];
      if (!redirectObj?.redirect) {
        console.error("❌ business_06のredirectが見つからない:", redirects, index);
        return;
      }
      const result = {
        index,
        scores: {},
      };
      onAnswer(result);
      return;
    }

    const selectedScore = scores[index];
    if (!selectedScore) {
      console.error("❌ 該当indexのscoresが見つかりません:", scores, index);
      return;
    }

    const tagType = Object.keys(selectedScore).find((key) => key !== "score");
    const tagValue = selectedScore[tagType];

    if (!tagType || !tagValue) {
      console.warn("⚠️ スコアにtag情報がありません:", selectedScore);
      return;
    }

    if (isBusiness) {
      const formatted = {
        index,
        scores: {
          [tagType]: tagValue,
          score: selectedScore.score || 1,
        },
      };
      onAnswer(formatted);
    } else {
      const tagObject = {
        tags: {
          [tagType]: tagValue,
        },
      };
      onAnswer(tagObject);
    }
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold text-center">{question.question}</h2>
      <div className="space-y-3 mt-4">
        {choices.map((choice, index) => {
          const tagKey = Object.keys(scores[index] || {}).find((key) => key !== "score");
          const tagVal = scores[index]?.[tagKey];
          const isSelected = selectedTags?.[tagKey] === tagVal ||
                             question.selectedGenres?.includes(tagVal);

          return (
            <Button
              key={index}
              onClick={() => handleClick(index)}
              className={`w-full px-4 py-3 rounded-full border-2 text-center font-semibold transition shadow-md
                ${isSelected
                  ? "bg-[#2f2301] text-white border-[#2f2301]"
                  : "bg-[#efeeea] text-[#2f2301] border-[#2f2301] hover:bg-[#2f2301] hover:text-white"}`}
            >
              {choice}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
